/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_EMP_EMPLOYEES_ITEM = {
  id: 'employees_sidebar',
  screenId: 'lab-emp-employees',
  label: 'Empleados',
  description: 'Alta, edición y consulta de legajos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Administrás el legajo de cada trabajador: datos personales, contacto, cuenta bancaria, datos para liquidar sueldos y exportar al Libro de Sueldos Digital (LSD) y F.931.',
      },
      {
        title: 'Antes de empezar',
        paragraphs: [
          'Conviene tener categorías de empleados y conceptos de liquidación cargados si vas a asignar sueldo y novedades después.',
          'La cuenta de gasto (sueldos) debe existir en Finanzas → centros de costo / cuentas de gasto.',
        ],
      },
      {
        title: 'Paso 1 — Lista',
        bullets: [
          'Interruptor «Solo empleados activos» — marcado por defecto; desmarcá para ver también inactivos.',
          'Columnas: CUIL, Nombre. Tocá el lápiz para editar; tocá otra parte de la fila para ver detalle.',
          'Botón + para nuevo empleado. Podés exportar la lista.',
        ],
      },
      {
        title: 'Paso 2 — Datos principales (alta / edición)',
        fields: [
          {
            label: 'CUIL',
            description: '11 dígitos, obligatorio y único. Al completarlo el sistema consulta ARCA/AFIP y puede completar nombre, provincia y domicilio fiscal.',
          },
          { label: 'Nombre', description: 'Obligatorio. Si ARCA respondió, queda bloqueado hasta que cambies el CUIL.' },
          { label: 'Provincia', description: 'Opcional. Lista del sistema.' },
          {
            label: 'Cuenta de gasto (sueldos)',
            description: 'Opcional. Buscador de centros de costo imputables; se usa al contabilizar sueldos.',
          },
          { label: 'Empleado activo', description: 'Solo en edición. Desmarcá si el empleado ya no trabaja en la empresa.' },
        ],
      },
      {
        title: 'Paso 3 — Fechas y contacto',
        fields: [
          { label: 'Nacimiento / Ingreso / Egreso', description: 'Opcionales. La fecha de ingreso se usa para antigüedad en liquidación.' },
        ],
        bullets: [
          'Teléfonos, correos y cuentas bancarias (CBU): podés agregar varias filas con descripción + valor.',
          'Direcciones: varias posibles. La primera puede autocompletarse como «Fiscal» desde ARCA.',
        ],
      },
      {
        title: 'Paso 4 — Liquidación de sueldos',
        fields: [
          { label: 'Categoría', description: 'Categoría laboral del empleado (Laboral → Categorías).' },
          {
            label: 'Tipo de sueldo',
            description: 'Mensual, diario o por hora. Define cómo se interpreta el básico en la liquidación.',
          },
          { label: 'Convenio (texto)', description: 'Nombre del CCT u observación interna.' },
          {
            label: '% Antigüedad (override)',
            description: 'Opcional. Porcentaje fijo de antigüedad si querés reemplazar el cálculo automático por fecha de ingreso.',
          },
        ],
      },
      {
        title: 'Paso 5 — Datos previsionales (LSD / F.931)',
        intro: 'Catálogos del sistema (obra social, situación de revista, modalidad de contratación, etc.):',
        bullets: [
          'Obra social, situación de revista, modalidad de contratación, condición, actividad.',
          'Zona desfavorable (adicional jubilatorio), siniestrado, código de localidad LSD.',
          'Régimen (jubilado/SIPA), aportes adicionales.',
          'Casillas: trabajador en CCT, SCVO, corresponde reducción de contribuciones.',
        ],
        paragraphs: [
          'Estos datos alimentan el Libro de Sueldos Digital y las declaraciones previsionales.',
        ],
      },
      {
        title: 'Paso 6 — Conceptos asignados (solo edición)',
        paragraphs: [
          'En la edición de un empleado ya guardado podés marcar conceptos de liquidación que no aplican a todos (Laboral → Conceptos) y opcionalmente fijar un valor numérico por empleado.',
          'Tocá «Guardar conceptos» para persistir solo esa parte, sin cerrar la edición del legajo.',
        ],
      },
      {
        title: 'Detalle (solo lectura)',
        bullets: [
          'Al tocar una fila (fuera del lápiz) ves CUIL, nombre, provincia, fechas, contactos, direcciones y datos de auditoría (quién creó o modificó).',
        ],
      },
    ],
  },
}
